import { getToken, setToken, removeToken } from '@/utils/auth'
const state = {
  token: getToken()
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  REMOVE_TOKEN(state) {
    state.token = ''
  }
}

const actions = {
  setToken({ commit }, token) {
    return new Promise(resolve => {
      setToken(token)
      commit('SET_TOKEN', token)
      resolve()
    })
  },
  removeToken({ commit }) {
    return new Promise(resolve => {
      removeToken()
      commit('REMOVE_TOKEN')
      resolve()
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js